import constants from "../config/constants";
import { getRequest, postRequest } from "../libs/AxiosService.util";

export async function serviceGetHealthCare(params) {
  return await postRequest("doctors/professionals/list", params,constants.DEFAULT_DOCTOR_URL);
}
export async function serviceGetHealthCareDetail(params) {
  return await postRequest("doctors/professional/details", params,constants.DEFAULT_DOCTOR_URL);
}
export async function serviceGetHealthCareCalendarDetail(params) {
  return await postRequest("doctors/available-days", params,constants.DEFAULT_DOCTOR_URL);
}
export async function serviceExportHealthCare(params) {
  return await postRequest("doctors/professionals/list/export", params,constants.DEFAULT_DOCTOR_URL);
}
export async function serviceGetHealthCareList(list, otherParams = {}) {
    return await postRequest('list', { list: list, ...otherParams, }, constants.DEFAULT_DOCTOR_URL);
}
export async function serviceCreateDoctorAvailabilty(params) {
    return await postRequest('doctors/create-availability',params, constants.DEFAULT_DOCTOR_URL);
}
export async function serviceGetConfigSlotDoctor(params) {
  return await getRequest("doctors/slots/config", params,constants.DEFAULT_DOCTOR_URL);
}
export async function serviceDoctorAvailabilty(params) {
    return await postRequest('doctors/availability',params, constants.DEFAULT_DOCTOR_URL);
}
export async function serviceDoctorAvailabilityByDoctors(params) {
    return await postRequest('doctors/availability/by/doctors',params, constants.DEFAULT_DOCTOR_URL);
}
export async function serviceCreateHealthCare(params) {
    return await postRequest('doctors/create/professional',params, constants.DEFAULT_DOCTOR_URL);
}
export async function serviceGetCommonSalesEmployee(params) {
  return await postRequest("list", params, constants.DEFAULT_DOCTOR_URL);
}
export async function serviceExportDoctorAvailability(params) {
  return await postRequest("doctors/availability/by/doctors/export", params,constants.DEFAULT_DOCTOR_URL);
}

export async function serviceGetDoctorWalletLedgers(params) {
  return await postRequest("doctors/wallet/ledger", params, constants.DEFAULT_DOCTOR_URL);
}

